let items = document.querySelector(".header__inline-menu")?.querySelectorAll("details") || null;

if(items){
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});
}
const swiper = new Swiper(".testimonial-box-wrapper", {
  loop: false,
  speed: 1000,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  }, 
  pagination: {
    el: ".testimonial-box-wrapper .swiper-pagination",
    clickable: true
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  breakpoints: {
    0: { slidesPerView: 1.2, spaceBetween: 10, loop: true, centeredSlides: true },
    480: { slidesPerView: 1.2, spaceBetween: 10, loop: true, centeredSlides: true },
    575: { slidesPerView: 2.2, spaceBetween: 10, loop: true, centeredSlides: true },
    750: { slidesPerView: 2.2, spaceBetween: 20, loop: true, centeredSlides: true },
    992: { slidesPerView: 3.2, spaceBetween: 20, loop: true, centeredSlides: true },
    1200: { slidesPerView: 3.5, spaceBetween: 20 },
  },
});

if (document.body.clientWidth < 991) {
  const icon_swiper = new Swiper(".text-with-icon-blocks", {
    loop: true,
    speed: 1000, 
    pagination: {
      el: ".text-with-icon-blocks .swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    effect: "slide",
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 10 },
      400: { slidesPerView: 1, spaceBetween: 10 },
      575: { slidesPerView: 2, spaceBetween: 10 },
      768: { slidesPerView: 3, spaceBetween: 30 },
      990: { slidesPerView: 3, spaceBetween: 30 },
    },
  }); 
 

}

if (document.body.clientWidth < 1140) {
  const icon_swiper_block = new Swiper(".icon-block-blocks", {
    loop: true,
    slidesPerView: 4,
    speed: 1000, 
    pagination: {
      el: ".icon-block-blocks .swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    effect: "slide",
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 10 },
      400: { slidesPerView: 2, spaceBetween: 10 },
      575: { slidesPerView: 3, spaceBetween: 10 },
      750: { slidesPerView: 4, spaceBetween: 30 },
      991: { slidesPerView: 4, spaceBetween: 30 },
    },
  }); 
}


//footer accordian
// accordions js start
function nav_taggol() {
  const accordionss = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    tab_content.style.maxHeight = tab_content.scrollHeight + "px";
  };
  
  const closeAccordion = (accordion) => {
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(tab_content){
      tab_content.style.maxHeight = null;
    }
  };

  accordionss.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    if(intro && tab_content){
        intro.onclick = (e) => {
          if (tab_content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordionss.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });
}
nav_taggol();


//quantity custom logic oin product page bundle logic

/* document.addEventListener("DOMContentLoaded", function () {
  const productF = document.querySelector('.product-form form');
  
   document.querySelectorAll(".bundle_minus").forEach(function (minusBtn) {
    minusBtn.addEventListener("click", function () {
      var qtyInput = this.closest(".bundle_qty_main").querySelector("input");
      let newQty = Math.max(0, parseInt(qtyInput.value) - 1);
      qtyInput.value = newQty;

      updateHiddenInput(); // Update hidden input after quantity change
    });
  });

  document.querySelectorAll(".bundle_plus").forEach(function (plusBtn) {
    plusBtn.addEventListener("click", function () {
      var qtyInput = this.closest(".bundle_qty_main").querySelector("input");
      qtyInput.value = parseInt(qtyInput.value) + 1;

      updateHiddenInput(); // Update hidden input after quantity change
    });
  });

  function updateHiddenInput() {
    let selectedProducts = {};
    let index = 1; // Start index from 1

    // Loop through all inputs and get only products with qty > 0
    document.querySelectorAll("[data-quantity-variant-id]").forEach(input => {
      let variantId = input.getAttribute("data-quantity-variant-id");
      let quantity = parseInt(input.value) || 0;

      if (quantity > 0) {
        selectedProducts[index] = {
          id: variantId,
          quantity: quantity
        };
        index++; // Increment index for the next product
      }
    });

    // Create or update hidden input
    const existingInput = productF.querySelector("input[name='properties[_Bundle Product]']");
    if (existingInput) {
      existingInput.value = JSON.stringify(selectedProducts);
    } else {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[_Bundle Product]";
      input.value = JSON.stringify(selectedProducts);
      input.id = "bundle-product";
      productF.appendChild(input);
    }

    console.log("Updated hidden input value:", selectedProducts);
  }
});
 */

// bundle product full logic 
//document.addEventListener("DOMContentLoaded", function () {
  // Quantity decrement function
 /*  document.querySelectorAll(".bundle_minus").forEach(function (minusBtn) {
    minusBtn.addEventListener("click", function () {
      console.log("click bundle...minus");
      var qtyInput = this.closest(".bundle_qty_main").querySelector("input");
      let currentQty = parseInt(qtyInput.value); // Get the current quantity value
      let newQty = Math.max(0, currentQty - 1); // Decrease by 1 but not below 0
      qtyInput.value = newQty; // Update the input value with the new quantity
      //console.log("newQtynewQty",newQty);
      // You can also call your updateHiddenInput() function here if needed
    });
  });

  // Quantity increment function
  document.querySelectorAll(".bundle_plus").forEach(function (plusBtn) {
    plusBtn.addEventListener("click", function () {
      console.log("click bundle...plus");
      var qtyInput = this.closest(".bundle_qty_main").querySelector("input");
      let currentQty = parseInt(qtyInput.value); // Get the current quantity value
     // console.log("currentQty",currentQty);
      qtyInput.value = currentQty + 1; // Increase by 1
     // console.log("qtyInput",qtyInput);
      // You can also call your updateHiddenInput() function here if needed
    });
  }); */
// Run this only once when the page loads (NOT inside onSubmitHandler)


// paypal btn hide on check a input required
const paypalBtn = document.querySelector('.product__info-container');
if(paypalBtn){

  paypalBtn.classList.add("paypal-hide"); 
}

function validateRequiredInputs() {

  const requiredInputs = document.querySelectorAll(".input_element[required]");
  let hasError = false;

  requiredInputs.forEach(input => {
    if (!input.value.trim()) {
      hasError = true;
    }
    console.log("hasError",hasError);
  });

  if (paypalBtn) {
    if (hasError) {
      paypalBtn.classList.add("paypal-hide");   // Hide button
    } else {
      paypalBtn.classList.remove("paypal-hide"); // Show button
    }
  }
}

// related product ionput fields hide show

const inputFields = document.querySelector(".bundle_product_slider_wrapper_2");
const openBtn = document.querySelector(".related-condition-btn.open-fields");
const closeBtn = document.querySelector(".related-condition-btn.close-fields");
const buttons = document.querySelectorAll('.related-condition-btn');


if (openBtn && inputFields) {
  openBtn.addEventListener("click", () => {
    inputFields.classList.remove("hidden");
  });
}

 if (openBtn && inputFields) {
    closeBtn.addEventListener("click", () => {
      inputFields.classList.add("hidden");
    });
  }
// active  class add on  btn
buttons.forEach(button => {
  button.addEventListener('click', function() {

    // Remove active from all buttons
    buttons.forEach(btn => btn.classList.remove('active'));

    // Add active to clicked button
    this.classList.add('active');

  });
});//wnd logic

//final logic qty 
document.addEventListener('DOMContentLoaded', function () {

  function getFinalPrice() {
    const atcBtn = document.querySelector('.atc-btn-price');
    if (!atcBtn) return 0;

    // ✅ MAIN UNIT PRICE (constant)
    const mainUnitPrice = parseInt(atcBtn.getAttribute('data-atc-price')) || 0;

    // ✅ MAIN QTY (correct input)
    let mainQty = 1;
    const qtyInputs = document.querySelectorAll('input[name="quantity"]');
    console.log("qtyInputs",qtyInputs);
    qtyInputs.forEach(input => {
      if (input.offsetParent !== null) {
        mainQty = parseInt(input.value) || 1;
      }
    });

    const mainTotal = mainUnitPrice * mainQty;
    console.log("mainTotal",mainTotal);
    // ✅ BUNDLE TOTAL
    let bundleTotal = 0;
    document.querySelectorAll('.bundle-products-wrapper').forEach(bundle => {
      const price = parseFloat(bundle.querySelector('.related-pdp-price')?.getAttribute('data-price')) || 0;
      const qty = parseInt(bundle.querySelector('.bundle_item_qty')?.value || 0);
      bundleTotal += price * qty;
    });
    // ===================================================
     let extraTotal = 0;
      const specialWrapper = document.querySelector('.bundle_product_slider_wrapper_2');

    const openBtn = document.querySelector('.open-fields');
    // ✅ check active state
    const isSpecialActive = openBtn && openBtn.classList.contains('active');

    if (isSpecialActive) {
        specialWrapper.querySelectorAll('.bundle-products-wrapper').forEach(item => {
          const price = parseFloat(item.getAttribute('data-price')) || 0;
          extraTotal += price;
          console.log("extraTotal",extraTotal);
        });
      }
    return mainTotal + bundleTotal + extraTotal;
  }

  function updateUI() {
    const atcBtn = document.querySelector('.atc-btn-price');
    if (!atcBtn) return;

    const finalTotal = getFinalPrice();

    let formattedPrice;
    if (window.theme?.formatMoney) {
      formattedPrice = window.theme.formatMoney(finalTotal, window.shopMoneyFormat);
    } else if (window.Shopify?.formatMoney) {
      formattedPrice = Shopify.formatMoney(finalTotal, window.shopMoneyFormat);
    } else {
      formattedPrice = (finalTotal / 100).toFixed(2);
    }

    atcBtn.textContent = formattedPrice;

    console.log("FINAL:", finalTotal);
  }

  // =====================================================
  // ➕➖ BUNDLE BUTTONS
  // =====================================================
  document.querySelectorAll('.bundle_plus, .bundle_minus').forEach(button => {
    button.addEventListener('click', function () {

      const wrapper = button.closest('.bundle-products-wrapper');
      if (!wrapper) return;

      const input = wrapper.querySelector('.bundle_item_qty');
      const plusBtn = wrapper.querySelector('.bundle_plus.qty-limit-plus');

      let qty = parseInt(input?.value || 0);

      if (button.classList.contains('bundle_plus')) {
        qty += 1;
      } else {
        qty = Math.max(0, qty - 1);
      }

      input.value = qty;

      // optional disable
      if (plusBtn) {
        if (qty >= 1) {
          plusBtn.classList.add('disabled');
        } else {
          plusBtn.classList.remove('disabled');
        }
      }

      updateUI(); // 🔥 ONLY CALL THIS
    });
  });

  // =====================================================
  // 🔢 MAIN QTY EVENTS (IMPORTANT FIX)
  // =====================================================
  document.addEventListener('input', function (e) {
    if (e.target.matches('input[name="quantity"]')) {
      updateUI();
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.quantity__button')) {
      setTimeout(updateUI, 100);
    }
  });

document.addEventListener('click', function (e) {

  // 👉 OPEN
  if (e.target.closest('.open-fields')) {
    isSpecialActive = true;

    const wrapper = document.querySelector('.bundle_product_slider_wrapper_2');
    if (wrapper) wrapper.classList.remove('hidden');

    updateUI();
  }

  // 👉 CLOSE
  if (e.target.closest('.close-fields')) {
    isSpecialActive = false;

    const wrapper = document.querySelector('.bundle_product_slider_wrapper_2');
    if (wrapper) wrapper.classList.add('hidden');

    updateUI();
  }

});
  // =====================================================
  // 🚀 INITIAL
  // =====================================================
  updateUI();

});

//});

/* document.addEventListener("DOMContentLoaded", function () {
  const productForm = document.querySelector('.product-form.bundle-form form');
if (!productForm) {
    console.warn("Warning: .product-form form not found! Skipping bundle logic.");
    return; // Exit the function to prevent errors on other pages
  }

  // Function to refresh the cart drawer
  function refreshCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.refresh === "function") {
      cartDrawer.refresh(true);
    } else {
      console.error("Error: cart-drawer element or refresh function not found!");
    }
  }

  // Function to add items to cart via AJAX
  function addToCart(items) {
    fetch('/cart/add.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    })
    .then(response => response.json())
    .then(data => {
      console.log("Items added to cart:", data);
      refreshCartDrawer(); // Refresh the cart drawer
    })
    .catch(error => {
      console.error("Error adding items to cart:", error);
    });
  }

 // Quantity decrement function
   document.querySelectorAll(".bundle_minus").forEach(function (minusBtn) {
    minusBtn.addEventListener("click", function () {
      console.log("click bundle...minus");
      var qtyInput = this.closest(".bundle_qty_main").querySelector("input");
      let newQty = Math.max(0, parseInt(qtyInput.value) - 1);
      qtyInput.value = newQty;

      //updateHiddenInput(); // Update hidden input after quantity change
    });
  });

  document.querySelectorAll(".bundle_plus").forEach(function (plusBtn) {
    plusBtn.addEventListener("click", function () {
       console.log("click bundle...plus");
      var qtyInput = this.closest(".bundle_qty_main").querySelector("input");
      qtyInput.value = parseInt(qtyInput.value) + 1;

     // updateHiddenInput(); // Update hidden input after quantity change
    });
  });

  // Function to update hidden input with bundle product details
  function updateHiddenInput() {
    let selectedProducts = {};
    let index = 1;

    document.querySelectorAll("[data-quantity-variant-id]").forEach(input => {
      let variantId = input.getAttribute("data-quantity-variant-id");
      console.log("variantId",variantId);
      let quantity = parseInt(input.value) || 0;

      if (quantity > 0) {
        selectedProducts[index] = {
          id: parseInt(variantId),
          quantity: quantity
        };
        index++;
      }
    });

    let existingInput = productForm.querySelector("input[name='properties[_Bundle Product]']");
    if (existingInput) {
      existingInput.value = JSON.stringify(selectedProducts);
    } else {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[_Bundle Product]";
      input.value = JSON.stringify(selectedProducts);
      input.id = "bundle-product";
      productForm.appendChild(input);
    }

    console.log("Updated bundle products:", selectedProducts);
  }
  // Handle Add to Cart button click
  const submitButton = document.querySelector(".bundle-add-to-cart");
  console.log("submitButton",submitButton);
  if (submitButton) {
    submitButton.addEventListener("click", function (e) {
      console.log("cart-btn click...");
      e.preventDefault();

      let bundleInput = productForm.querySelector("input[name='properties[_Bundle Product]']");
      let bundleItems = bundleInput && bundleInput.value !== "{}" 
        ? Object.values(JSON.parse(bundleInput.value)) 
        : [];

      // Get main product form data
      let formData = new FormData(productForm);

      // Extract main product ID & quantity
      let mainProductId = formData.get("id");
      let mainProductQty = parseInt(formData.get("quantity")) || 1;

      // Build the array of items to add
      let allItems = [{ id: mainProductId, quantity: mainProductQty }];

      if (bundleItems.length > 0) {
        allItems = allItems.concat(bundleItems);
      }

      // Add main + bundle products to cart
      addToCart(allItems);
    });
  } else {
    console.error("Error: .product-form__submit button not found!");
  }
});//end bundle logic */

// ====== faq page accordian  ======
document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        if (!localStorage.getItem("firstLoad")) {
            const modal = document.querySelector(".custom-model-main");
            if (modal) {
                modal.classList.add("model-open");
                localStorage.setItem("firstLoad", "true");
            }
        }
    }, 3000);

    document.querySelectorAll(".close-btn, .bg-overlay").forEach(function (element) {
        element.addEventListener("click", function () {
            const modal = document.querySelector(".custom-model-main");
            if (modal) {
                modal.classList.remove("model-open");
            }
        });
    });

    if (document.body.clientWidth < 991) {
        const lastCollage = document.querySelector(".last_collage.image_banner_collage_item");
        const collageSecond = document.querySelector(".collage_second.image_banner_collage_item");
        if (lastCollage && collageSecond) {
            collageSecond.after(lastCollage);
        }
    }

    if (document.body.clientWidth < 750) {
        const imageMedia = document.querySelector(".about-image-text-bg.image-with-text__media-item");
        const imageText = document.querySelector(".about-image-text-bg.image-with-text__text-item");
        if (imageMedia && imageText) {
            imageText.after(imageMedia);
        }
    }

    document.querySelectorAll(".faq_accordion .accordion").forEach(function (accordion) {
        accordion.addEventListener("click", function () {
            const isOpen = accordion.classList.contains("is-open");
            document.querySelectorAll(".faq_accordion .accordion").forEach(function (item) {
                item.classList.remove("is-open");
                const content = item.nextElementSibling;
                if (content) content.style.maxHeight = "0px";
            });
            if (!isOpen) {
                accordion.classList.add("is-open");
                const content = accordion.nextElementSibling;
                if (content) content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });

    document.querySelectorAll(".faq-page_main_wrapper .accordion").forEach(function (accordion) {
        accordion.addEventListener("click", function () {
            const isOpen = accordion.classList.contains("is-open");
            document.querySelectorAll(".faq-page_main_wrapper .accordion").forEach(function (item) {
                item.classList.remove("is-open");
                const content = item.nextElementSibling;
                if (content) content.style.maxHeight = "0px";
            });
            if (!isOpen) {
                accordion.classList.add("is-open");
                const content = accordion.nextElementSibling;
                if (content) content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });
});

// blog
document.addEventListener("DOMContentLoaded", () => {
  // Handle FAQ buttons
  const buttons = document.querySelectorAll(".blog-btn");

  buttons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault(); // Prevent default anchor behavior

      // Remove the active class from all buttons
      buttons.forEach((btn) => btn.classList.remove("active"));

      // Add the active class to the clicked button
      button.classList.add("active");

      // Redirect to the URL specified in the href attribute
      window.location.href = button.getAttribute("href");
    });
  });
});

function toggleDropdown() {
  var dropdownMenu = document.getElementById("dropdownMenu");
  var dropdownIcon = document.getElementById("dropdownIcon");
  if (dropdownMenu.style.display === "block") {
    dropdownMenu.style.display = "none";
    dropdownIcon.style.transform = "rotate(0deg)";
  } else {
    dropdownMenu.style.display = "block";
    dropdownIcon.style.transform = "rotate(180deg)";
  }
}
 
// faq tabs toggal start
function faq_toggle() {
  const buttons = document.querySelectorAll("[data-faq_content]");

  buttons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const targetId = this.getAttribute("data-faq_content").replace("#", "");
      const content = document.querySelector(`[data-faq-main-data="${targetId}"]`);

      const isOpen = this.classList.contains("is_open");

      // Close all first
      document.querySelectorAll("[data-faq_content]").forEach(b => b.classList.remove("is_open"));
      document.querySelectorAll(".acco-content").forEach(c => c.classList.remove("is_open"));

      // If already open → keep closed (toggle off)
      if (!isOpen) {
        this.classList.add("is_open");
        if (content) content.classList.add("is_open");
      }
    });
  });
}

faq_toggle();
// faq tabs toggal end

// reload more btn on blog page
document.addEventListener("DOMContentLoaded", function () {
    const loadMoreBtn = document.querySelector("[data-btn-load-more]");

    // Check if the button exists before adding an event listener
    if (loadMoreBtn) {
        loadMoreBtn.addEventListener("click", function (event) {
            event.preventDefault();

            const hiddenArticles = document.querySelectorAll(".blog-articles .blog-articles__article.hidden");

            hiddenArticles.forEach((item, index) => {
                if (index < 6) {
                    item.classList.remove("hidden");
                }
            });

            // Check if there are no more hidden articles
            if (document.querySelectorAll(".blog-articles .blog-articles__article.hidden").length === 0) {
                loadMoreBtn.classList.add("hidden"); // Hide the button when all articles are visible
            }
        });
    } 
});

// first itme reload add active class on blog page 
document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(".blog-btn");
    const dropdownButton = document.querySelector(".dropdown-button");

    if (buttons.length > 0) {
        // Retrieve saved tag from localStorage or use the first button text
        let savedTag = localStorage.getItem("selectedTag") || buttons[0].textContent.trim();

        // Update dropdown button text
        dropdownButton.childNodes[0].textContent = savedTag;

        // Set active class to the correct button
        buttons.forEach(button => {
            if (button.textContent.trim() === savedTag) {
                button.classList.add("active");
            }
        });

        // Add event listeners to buttons
        buttons.forEach(button => {
            button.addEventListener("click", function () {
                buttons.forEach(btn => btn.classList.remove("active")); // Remove active class
                this.classList.add("active"); // Add active class

                const selectedText = this.textContent.trim();
                dropdownButton.childNodes[0].textContent = selectedText; // Update dropdown text

                // Save selected tag to localStorage
                localStorage.setItem("selectedTag", selectedText);
            });
        });
    }
});



// header menu close icon trigger
document.querySelector('.header-menus-close').addEventListener('click', function() {
  let menuIcon = document.querySelector('.header__icon.header__icon--menu');
  if (menuIcon) { 
    menuIcon.click();
  }
});

// header menu toggle logic 
document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".menu-drawer__menu-item");

  menuItems.forEach((item) => {
    item.addEventListener("click", function (e) {
      e.stopPropagation(); // important: prevent closing on outside click

      // Remove open from others
      menuItems.forEach((el) => {
        if (el !== item) {
          el.classList.remove("open");
        }
      });

      // Toggle for current item only
      item.classList.toggle("open");
    });
  });
});

// name input element count 

document.addEventListener("DOMContentLoaded", function () {
  // Loop through all character input wrappers
  document.querySelectorAll(".characters-input").forEach(wrapper => {
    let input = wrapper.querySelector("input");
    let name = wrapper.querySelector(".namebox-heading");

    if (input && name) {
      let maxChars = parseInt(name.getAttribute("data-name")); // get number directly
      if (!isNaN(maxChars)) {
        input.setAttribute("maxlength", maxChars);

        // Create counter
        let counter = document.createElement("span");
        counter.textContent = `(${maxChars}/${maxChars})`;
        counter.style.marginLeft = "10px";
        name.appendChild(counter);

        // Update on input
        input.addEventListener("input", function () {
          let currentLength = input.value.length;
          let remainingChars = maxChars - currentLength;
          counter.textContent = `(${remainingChars}/${maxChars})`;
          validateRequiredInputs();
        });
      }
    }
  });
});

// custom name propertices pass 

// Namebox input syncing
document.addEventListener("DOMContentLoaded", function () {
    // Check if namebox exists before adding event listener
    //let namebox = document.getElementById("namebox");
    // let customInputName = document.getElementById("custom-input_name");

    // if (namebox && customInputName) {
    //     namebox.addEventListener("input", function () {
    //         customInputName.value = this.value;
    //     });
    // } else {
    //     console.warn("Element with ID 'namebox' or 'custom-input_name' not found.");
    // }

  // Neinbox input syncing (handling multiple input fields)
    let neinInputs = document.querySelectorAll(".input_element_nein");
    let customInputNain = document.getElementById("custom-input_nain");
    
    if (neinInputs.length > 0 && customInputNain) {
        // Function to sync the inputs and update the custom input field
        function updateCustomInput() {
            let values = [];
            document.querySelectorAll(".input_element_nein").forEach((el) => {
                if (el.value.trim() !== "") {  // Only push non-empty values
                    values.push(el.value);
                }
            });
            customInputNain.value = values.join(", "); // Store non-empty values as comma-separated
        }
    
        // Attach 'input' event listener to each input field
        neinInputs.forEach((input) => {
            input.addEventListener("input", updateCustomInput);
        });
    
        // Initial update in case the page loads with some inputs already filled
        updateCustomInput();
    
    } else {
        console.warn("Elements with class 'input_element_nein' or ID 'custom-input_nain' not found.");
    }

});

// font pack select dropdown
document.addEventListener('DOMContentLoaded', function () {

  const dropdownGroups = document.querySelectorAll('.custom-dropdown');
  const allInputs = document.querySelectorAll('.characters-input');
  const allInputs_not =
    document.querySelectorAll('.characters-input[front_selectro_not_avalable] input.input_element') || null;
    // propertices pass
    const firstFont = document.querySelector('.dropdown-list li');
    const selectedFont = document.getElementById('selectedFont');

    if (firstFont && selectedFont) {
      selectedFont.value = firstFont.dataset.value;
    }
    document.querySelectorAll('.dropdown-list li').forEach(item => {
      item.addEventListener('click', function() {

        const selectedFont = this.dataset.value;

        document.getElementById('selectedFont').value = selectedFont;

      });
    });

  dropdownGroups.forEach((dropdownGroup, index) => {

    const dropdownToggle = dropdownGroup.querySelector('.dropdown-toggle');
    const dropdownList = dropdownGroup.querySelector('.dropdown-list');
    const dropdownItems = dropdownList.querySelectorAll('li');
    const toggleSpan = dropdownToggle.querySelector('.selected-text');

    // Each dropdown controls its corresponding input
    const textInput =
  dropdownGroup
    .closest('[input-main-wapper]')
    ?.querySelector('.characters-input input.input_element');

    // --- Set font function ---
    async function setFont(
      value,
      fontUrl,
      inputget,
      fontSize = null,
      desktopHeight = null,
      mobileHeight = null
    ) {

  if (!inputget) return;

  try {

    if (fontUrl) {
      const fontFace = new FontFace(value, `url(${fontUrl})`);
      await fontFace.load();
      document.fonts.add(fontFace);
    }

    // MAIN INPUT
    inputget.style.fontFamily = `"${value}", sans-serif`;
    inputget.setAttribute('data-font', value);

    // RESPONSIVE FONT SIZE
    const isMobile = window.innerWidth <= 767;

    let finalFontSize = '';

    if (isMobile) {
      finalFontSize =
        mobileHeight ||
        desktopHeight ||
        fontSize;
    } else {
      finalFontSize =
        desktopHeight ||
        mobileHeight ||
        fontSize;
    }

    if (
      finalFontSize &&
      finalFontSize !== 'null' &&
      finalFontSize !== 'undefined'
    ) {

      inputget.style.fontSize =
        `${finalFontSize}px`;

    } else {

      inputget.style.removeProperty('font-size');

    }

    /*
    -----------------------------------
    front_selectro_not_avalable
    -----------------------------------
    */


    console.log("inputget",inputget);


  //  const notAvailableInputs =  inputget.closest('[data-main-front-textbox]')?.querySelectorAll('.characters-input[front_selectro_not_avalable] input.input_element');


    // if (notAvailableInputs.length > 0) {

    //   notAvailableInputs.forEach((input) => {

    //     // FONT FAMILY
    //     input.style.fontFamily =
    //       `"${value}", sans-serif`;

    //     input.setAttribute('data-font', value);

    //     // FONT SIZE
    //     if (
    //       finalFontSize &&
    //       finalFontSize !== 'null' &&
    //       finalFontSize !== 'undefined'
    //     ) {

    //       input.style.fontSize =
    //         `${finalFontSize}px`;

    //     } else {

    //       input.style.removeProperty('font-size');

    //     }

    //   });

    // }





if (inputget) {

  // Current wrapper of #namebox_f
  let currentWrapper = inputget.closest("[input-main-wapper]");

  const matchedInputs = [];

  // Loop through next wrappers
  while (currentWrapper) {

    // Move to next [input-main-wapper]
    currentWrapper = currentWrapper.nextElementSibling;

    // Stop if no more wrappers
    if (!currentWrapper) break;

    // Skip non wrapper elements
    if (!currentWrapper.hasAttribute("input-main-wapper")) {
      continue;
    }

    // Find .characters-input[front_selectro_not_avalable]
    const targetInput = currentWrapper.querySelector(
      '.characters-input[front_selectro_not_avalable] input.input_element'
    );

    // If NOT found -> stop loop
    if (!targetInput) {
      break;
    }

    // Store matched input
    matchedInputs.push(targetInput);
  }

  // console.log(matchedInputs);


  if (matchedInputs.length > 0) {

      matchedInputs.forEach((input) => {

        // FONT FAMILY
        input.style.fontFamily =
          `"${value}", sans-serif`;

        input.setAttribute('data-font', value);

        // FONT SIZE
        if (
          finalFontSize &&
          finalFontSize !== 'null' &&
          finalFontSize !== 'undefined'
        ) {

          input.style.fontSize =
            `${finalFontSize}px`;

        } else {

          input.style.removeProperty('font-size');

        }

      });

    }

}



    // Selected dropdown text
    if (toggleSpan) {

      toggleSpan.textContent = value;

      toggleSpan.style.fontFamily =
        `"${value}", sans-serif`;

      if (
        fontSize &&
        fontSize !== 'null' &&
        fontSize !== 'undefined'
      ) {

        toggleSpan.style.fontSize =
          `${fontSize}px`;

      } else {

        toggleSpan.style.removeProperty('font-size');

      }

    }

    // Dynamic height
    if (dropdownToggle) {

      const finalHeight = isMobile
        ? mobileHeight
        : desktopHeight;

      if (
        finalHeight &&
        finalHeight !== 'null' &&
        finalHeight !== 'undefined'
      ) {

        dropdownToggle.style.height =
          `${finalHeight}px`;

      } else {

        dropdownToggle.style.removeProperty('height');

      }

    }

  } catch (err) {

    console.warn('Font failed to load:', err);

  }
}

    // --- Default font load ---
    const activeItem = dropdownList.querySelector('li.active');

    if (activeItem) {

     setFont(
      activeItem.dataset.value,
      activeItem.dataset.font,
      textInput,
      activeItem.dataset.fontSize,
      activeItem.dataset.inputHeight,
      activeItem.dataset.mobileHeight
    );

      if (index == 0 && allInputs_not.length > 0) {

        allInputs_not.forEach(input => {

          setFont(
            activeItem.dataset.value,
            activeItem.dataset.font,
            input,
            activeItem.dataset.fontSize
          );

        });
      }

    } else if (dropdownItems.length > 0) {

      setFont(
        dropdownItems[0].dataset.value,
        dropdownItems[0].dataset.font,
        textInput,
        dropdownItems[0].dataset.fontSize,
        dropdownItems[0].dataset.inputHeight,
        dropdownItems[0].dataset.mobileHeight
      );

      if (index == 0 && allInputs_not.length > 0) {

        allInputs_not.forEach(input => {

          setFont(
            dropdownItems[0].dataset.value,
            dropdownItems[0].dataset.font,
            input,
            dropdownItems[0].dataset.fontSize
          );

        });
      }
    }

    // --- Toggle dropdown ---
    dropdownToggle.addEventListener('click', function (e) {

      e.stopPropagation();

      const isVisible = dropdownList.style.display === 'block';

      document.querySelectorAll('.dropdown-list').forEach(list => {
        list.style.display = 'none';
      });

      dropdownList.style.display = isVisible ? 'none' : 'block';
    });

    // --- Dropdown item click ---
   // CLICK EVENT
dropdownItems.forEach(item => {

  item.addEventListener('click', function () {

    const fontValue = this.dataset.value;
    const fontUrl = this.dataset.font;
    const fontSize = this.dataset.fontSize;

    const desktopHeight = this.dataset.inputHeight;
    const mobileHeight = this.dataset.mobileHeight;

    dropdownItems.forEach(li => li.classList.remove('active'));
    this.classList.add('active');

    setFont(
      fontValue,
      fontUrl,
      textInput,
      fontSize,
      desktopHeight,
      mobileHeight
    );

    dropdownList.style.display = 'none';

  });

});

  });

  // Close dropdown outside click
  document.addEventListener('click', function () {

    document.querySelectorAll('.dropdown-list').forEach(list => {
      list.style.display = 'none';
    });

  });


  // COLOR LOGIC
const colorSwatches = document.querySelectorAll('.font-color-swatch');

function applyColor(radio) {

  const inputContainer =
    radio.closest('.characters-input');

  const textInput =
    inputContainer?.querySelector('input.input_element');

  if (textInput) {

    textInput.setAttribute(
      'data-color',
      radio.value
    );

    // OPTIONAL
    // textInput.style.color = radio.value;

  }

}

// CHANGE EVENT
colorSwatches.forEach(radio => {

  radio.addEventListener('change', function () {

    // SAME GROUP ONLY
    const sameGroup =
      this.closest('.characters-input')
      ?.querySelectorAll('.font-color-swatch');
    sameGroup?.forEach(r => {
      r.removeAttribute('checked');
    });
    this.setAttribute(
      'checked',
      'checked'
    );
    applyColor(this);
  });
});

// DEFAULT LOAD
document.querySelectorAll('.characters-input').forEach(wrapper => {
  let checkedRadio =
    wrapper.querySelector('.font-color-swatch:checked');
  // IF NO CHECKED FOUND
  if (!checkedRadio) {
    checkedRadio =
      wrapper.querySelector('.font-color-swatch');
    if (checkedRadio) {
      checkedRadio.checked = true;
    }
  }
  if (checkedRadio) {
    checkedRadio.setAttribute(
      'checked',
      'checked'
    );
    applyColor(checkedRadio);
  }
});


  // Only letters allowed
const textInputs = document.querySelectorAll('.only-letters');

textInputs.forEach(input => {
  input.addEventListener('input', function () {
    // Remove all emojis only
    // This regex targets common emoji Unicode ranges
    const emojiRegex = /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF])/g;

    this.value = this.value.replace(emojiRegex, '');
  });
});

// end code font


// font family of related bundle product
  document.addEventListener("DOMContentLoaded", function () {
    const dropdownToggle = document.querySelector("#frontListSelect");
    const dropdownList = document.querySelector(".custom-dropdown.releted-font .dropdown-list");
    const inputField = document.querySelector(".related-input-font");
    const hiddenInput = document.querySelector("#selectedFont-relted");

    if (!dropdownToggle || !dropdownList || !inputField) return;

    // 👉 Open / Close dropdown
    dropdownToggle.addEventListener("click", function () {
      dropdownList.style.display =
        dropdownList.style.display === "none" || dropdownList.style.display === ""
          ? "block"
          : "none";
    });

    // 👉 Select font
    dropdownList.querySelectorAll("li").forEach((item) => {
      item.addEventListener("click", function () {
        const fontName = this.getAttribute("data-value");

        // 1. Set selected text
        dropdownToggle.querySelector(".selected-text").innerText = fontName;

        // 2. Apply font to input field
        inputField.style.fontFamily = fontName;

        // 3. Save font to hidden input
        hiddenInput.value = fontName;

        // 4. Close dropdown
        dropdownList.style.display = "none";
      });
    });

    // Close dropdown if clicked outside
    document.addEventListener("click", function (e) {
      if (!dropdownToggle.contains(e.target) && !dropdownList.contains(e.target)) {
        dropdownList.style.display = "none";
      }
    });

  });// end code bundle font -family


// connect swatch popup set on card product 

document.addEventListener("DOMContentLoaded", () => {
  // const body = document.body;

  document.querySelectorAll(".tab_image_media").forEach(img => {
    img.addEventListener("click", e => {
      e.preventDefault();

      const currentPopup = img.closest(".popup-main-wrapp")?.querySelector(".custom-instructions-images-popup");
      if (!currentPopup) return;

      const clickedSrc = img.src;

      // 🧹 Close any open popup first
      document.querySelectorAll(".custom-instructions-images-popup.popup-open").forEach(p => {
        if (p !== currentPopup) p.classList.remove("popup-open");
      });

      // 🟢 Toggle same popup if same image already shown
      const popupImg = currentPopup.querySelector(".popup-inner-content img");
      if (currentPopup.classList.contains("popup-open") && popupImg?.src === clickedSrc) {
        currentPopup.classList.remove("popup-open");
        // body.style.overflow = "";
        return;
      }

      // 🟢 Open popup and show clicked image
      currentPopup.classList.add("popup-open");
      // body.style.overflow = "hidden";
      currentPopup.querySelector(".popup-inner-content").innerHTML =
        `<img src="${clickedSrc}" alt="Selected Image" class="popup-selected-image">`;
    });
  });

  // 🔻 Close popup on close button or overlay click
  document.querySelectorAll(".instructions-images-popup-close-btn, .custom-instructions-images-popup").forEach(el => {
    el.addEventListener("click", e => {
      if (e.target.classList.contains("popup-inner-content")) return;
      const popup = el.closest(".custom-instructions-images-popup") || e.currentTarget;
      popup.classList.remove("popup-open");
      // body.style.overflow = "";
    });
  });
});

// //sticky header scroll
//     document.addEventListener("scroll", function () {

//       const scrollTop = window.scrollY;

//       if (scrollTop > 260) {
//         document.body.classList.add("scrolled-body");
//       } else {
//         document.body.classList.remove("scrolled-body");
//       }

//     });

});

// popup on product page form 

//popup code

document.addEventListener("DOMContentLoaded", function() {

  const popup = document.getElementById("inquiryPopup");
  const popupInner = document.querySelector(".custom-popup-inner");
  const openBtns = document.querySelectorAll("#openInquiryPopup");
  const closeBtn = document.getElementById("closeInquiryPopup");

  if (!popup || !popupInner) return;

  // ======================
  // OPEN POPUP (Multiple buttons)
  // ======================
  openBtns.forEach(function(btn) {
    btn.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation(); // drawer close logic stop kare
      popup.classList.add("active");
      document.body.style.overflow = "hidden";
    });
  });

  // ======================
  // CLOSE BUTTON
  // ======================
  if (closeBtn) {
    closeBtn.addEventListener("click", function(e) {
      e.stopPropagation();
      closePopup();
    });
  }

  // ======================
  // OUTSIDE CLICK CLOSE
  // ======================
  popup.addEventListener("click", function(e) {
    if (!popupInner.contains(e.target)) {
      closePopup();
    }
  });

  function closePopup() {
    popup.classList.remove("active");
    document.body.style.overflow = "";
  }

// not close popup on submit
  if (popup && popup.classList.contains("active")) {
    document.body.style.overflow = "hidden";
  }
}); // end form popup on product page

//  custom bundal code end
function custom_addtocart_fun(product,open_drawer){
  console.log("product",product);
      fetch(`${routes.cart_add_url}`,{ 
              method: 'POST',
              headers: { "Accept": "application/json", "Content-Type": "application/json" },
              body: JSON.stringify(product)
        })
        .then(response => response.json()).then(response => {     
          console.log(response);   
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally((e) => {
          // console.log("finally");
          if(open_drawer){
            const this_cartDrawer = document.querySelector('cart-drawer');
           // console.log("this_cartDrawer",this_cartDrawer);
            this_cartDrawer.refresh(true);
          }
        });
    }

    // tab PDP

document.addEventListener("DOMContentLoaded", function() {
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabContents = document.querySelectorAll(".tab-content");
  const tabHeadings = document.querySelectorAll(".content-title");

  if (tabButtons.length > 0) {
    // Default: First tab active
    tabButtons[0].classList.add("active");
    tabContents[0].classList.remove("hidden");
    tabHeadings[0].classList.remove("hidden");

    // Hide all others
    for (let i = 1; i < tabContents.length; i++) {
      tabContents[i].classList.add("hidden");
      tabHeadings[i].classList.add("hidden");
    }

    tabButtons.forEach((btn, index) => {
      btn.addEventListener("click", () => {
        // Reset all
        tabButtons.forEach(b => b.classList.remove("active"));
        tabContents.forEach(c => c.classList.add("hidden"));
        tabHeadings.forEach(h => h.classList.add("hidden"));

        // Activate clicked
        btn.classList.add("active");
        tabContents[index].classList.remove("hidden");
        tabHeadings[index].classList.remove("hidden");
      });
    });
  }
});
